/**
 * How a bank account is identified/input — an international IBAN, a local BBAN, or the raw
 * `bank_details` triplet (bank code + branch + account number) a form collects before it's
 * composed into an IBAN.
 */
export enum BankAccountIdentifierType {
  IBAN = 'iban',
  BBAN = 'bban',
  BANK_DETAILS = 'bank_details'
}

/**
 * A persisted/displayed bank account's identifier format — excludes `BANK_DETAILS`, which is a
 * payout-creation form input method (composed into an IBAN before anything is stored), never a
 * value a stored or realized creditor account actually carries.
 */
export type StoredBankAccountIdentifierType = Exclude<
  BankAccountIdentifierType,
  BankAccountIdentifierType.BANK_DETAILS
>;
